import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInquiry, IInquiryState } from "./inquiryModel";
import {
  getAllInquiry,
  getFollowupsByInquiryID,
  insertFollowUp,
  updateFollowUpStatus,
} from "./services/inquiry.services";

const initialState: IInquiryState = {
  loading: false,
  error: "",
  InquiryID: null,
  completeFollowupOpen: false,
  InquiryList: [],
  InquiryFollowupList: [],
  FilterInquiry: {
    Name: "",
    MobileNo: "",
    Email: "",
  },
};

const inquirySlice = createSlice({
  name: "inquiry",
  initialState,
  reducers: {
    setInquiryID: (state, action) => {
      state.InquiryID = action.payload;
    },
    clearInquiryID: (state) => {
      state.InquiryID = initialState.InquiryID;
    },
    setFilterInquiry: (state, action) => {
      state.FilterInquiry = action.payload;
    },
    clearFilterInquiry: (state) => {
      state.FilterInquiry = initialState.FilterInquiry;
    },
    openCompleteFollowupDialog: (state) => {
      state.completeFollowupOpen = true;
    },
    closeCompleteFollowupDialog: (state) => {
      state.completeFollowupOpen = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllInquiry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllInquiry.fulfilled,
      (state, action: PayloadAction<IInquiry[]>) => {
        state.loading = false;
        state.InquiryList = action.payload || [];
      }
    );
    builder.addCase(getAllInquiry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.InquiryList = [];
    });

    builder.addCase(updateFollowUpStatus.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateFollowUpStatus.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateFollowUpStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getFollowupsByInquiryID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getFollowupsByInquiryID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.InquiryFollowupList = action.payload || [];
    });
    builder.addCase(getFollowupsByInquiryID.rejected, (state, action) => {
      state.loading = false;
      state.InquiryFollowupList = initialState.InquiryFollowupList;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(insertFollowUp.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(insertFollowUp.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(insertFollowUp.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearInquiryID,
  setInquiryID,
  clearFilterInquiry,
  setFilterInquiry,
  openCompleteFollowupDialog,
  closeCompleteFollowupDialog,
} = inquirySlice.actions;
export default inquirySlice.reducer;
